module.exports = __webpack_public_path__ + "img/delete-h.8649741e.svg";